import Blue from '~/core';

new Blue({
  name: 'Document Download',
  selector: '.document-download',
  setup(documentDownload) {
    const input = document.querySelector('.disclaimer-checkbox');
    const button = document.querySelector('.download-btn');

    input.addEventListener('change', () => {
      if (input.checked) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
      }
    });
  },
});
